/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリースビジネスカテゴリ lv2（小分類）
 * @export
 * @interface PressReleaseBusinessCategoryLv2
 */
export interface PressReleaseBusinessCategoryLv2 {
    /**
     * 
     * @type {number}
     * @memberof PressReleaseBusinessCategoryLv2
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PressReleaseBusinessCategoryLv2
     */
    name: string;
}

export function PressReleaseBusinessCategoryLv2FromJSON(json: any): PressReleaseBusinessCategoryLv2 {
    return PressReleaseBusinessCategoryLv2FromJSONTyped(json, false);
}

export function PressReleaseBusinessCategoryLv2FromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseBusinessCategoryLv2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function PressReleaseBusinessCategoryLv2ToJSON(value?: PressReleaseBusinessCategoryLv2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

